<template>
  <div class="container">
    <div>
      <nav-bar title="登录"></nav-bar>
    </div>
    <div class="banner">
      <div class="tel">客服热线：<span style="color:#22b7ff">400-828-6128</span></div>
    </div>
    <div class="from">
      <van-form @submit="onSubmit">
        <van-field v-model="username" name="username" label="用户名" placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]" />
        <van-field v-model="password" type="password" name="password" label="密码" placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
        <van-field name="switch" label="记住账号密码">
          <template #input>
            <van-switch v-model="switchChecked" size="20" active-color="#22b7ff" />
          </template>
        </van-field>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" color="#22b7ff">
            登录
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      switchChecked: true
    }
  },
  created() {
    if (this.$store.state.username) {
      this.username = this.$store.state.username
    } else {
      this.username = localStorage.getItem('username')
    }
    if (this.$store.state.password) {
      this.password = this.$store.state.password
    } else {
      this.password = localStorage.getItem('password')
    }
  },
  methods: {
    async onSubmit(values) {
      console.log('submit', values)
      var params = new URLSearchParams()
      params.append('loginName', values.username) // 你要传给后台的参数值 key/value
      params.append('password', values.password)
      const { data } = await this.$http.request({
        url: '/erp4open_api/auction/loginForApp',
        method: 'post',
        data: params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      if (data.success) {
        if (values.switch) {
          // 保存与清除
          this.$store.commit('setInfo', { username: values.username, password: values.password })
        } else {
          this.$store.commit('quit')
        }
        this.$store.commit('setToken', data.data.token)
        this.$toast.success('恭喜您登录成功')
        this.getUserInfo()
        this.$router.push({
          path: '/home'
        })
      } else {
        this.$toast.fail(data.message)
      }
    },
    async getUserInfo() {
      var token = this.$store.state.token
      if (token) {
        const { data } = await this.$http.get('/erp4open_api/auction/getCurrentUser', {
          params: {
            token: token
          }
        })
        if (data.success) {
          this.$store.commit('setUserInfo', data.data.user)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
}
.banner {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ccc;
  .tel {
    width: 90%;
    height: 50px;
    line-height: 50px;
  }
}
.from {
  margin-top: 30px;
}
</style>
